import React from 'react';
import {Table, Loader, Icon} from 'semantic-ui-react';

export const AccessoriesRequestDetailsTable = ({loading, accessoriesRequestDetails}) => {
  return (
    loading ?
      <Table>
        <Table.Body>
          <Table.Row className='loader'>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table> :
      <Table striped className='dashboard-table'>
        <Table.Header className='orders-table-header'>
          <Table.Row>
            <Table.HeaderCell>Código</Table.HeaderCell>
            <Table.HeaderCell>Descripción</Table.HeaderCell>
            <Table.HeaderCell>Solicitado</Table.HeaderCell>
            {accessoriesRequestDetails.every((x) => x.delivery.toUpperCase() === 'S') ?
              <Table.HeaderCell></Table.HeaderCell> : null}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            accessoriesRequestDetails.map((detail, index) => {
              return <Table.Row key={index}>
                <Table.Cell>{detail.accessory}</Table.Cell>
                <Table.Cell>{detail.name}</Table.Cell>
                <Table.Cell>{detail.quantity}</Table.Cell>
                {detail.delivery.toUpperCase() === 'S' ?
                  <Table.Cell><Icon name='check' size='large' color='green' /></Table.Cell> : ''}
              </Table.Row>;
            })
          }
        </Table.Body>
      </Table>
  );
};
